export { CustomLegend } from './CustomLegend';
export type { CustomLegendProps, LegendSeries } from './CustomLegend';

